import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../../providers/ThemeProvider';

const GiftTitle = ({ title, img, imgAlt }) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <div className="tile-header__text">{title}</div>
      <div className="tile-header__picture">
        <img alt={imgAlt} src={img} />
      </div>
      <style jsx>{`
        .tile-header__text {
          padding-right: 200px;
        }

        @media (max-width: ${theme.breakpoints.mdDown}) {
          .tile-header__picture {
            display: none;
          }

          .tile-header__text {
            padding-right: 0;
          }
        }
      `}</style>
    </>
  );
};

GiftTitle.propTypes = {
  img: PropTypes.string.isRequired,
  imgAlt: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default GiftTitle;
